import { useMutation } from '@tanstack/react-query';
import { triggerCaseSync } from 'services/ClaimscoreApiService/Sync';
import {
  TriggerCaseSyncPayload,
  TriggerCaseSyncResponse,
} from 'services/ClaimscoreApiService/Sync/types';

export const useTriggerCaseSync = () =>
  useMutation<TriggerCaseSyncResponse, Error, TriggerCaseSyncPayload>({
    mutationFn: (payload) => triggerCaseSync(payload),
  });
